module.exports = __webpack_public_path__ + "img/article4-3.1cd2c351.jpg";